import { FC, useCallback, useRef, useState } from 'react'

import Webcam from 'react-webcam'

import { dataUrlToFile } from 'shared/lib/convert-base64-file'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { Loader } from 'shared/ui/loader'

import { SelectTypeFile } from './ui/select-type-file'

import { Props } from './model'
import s from './styles.module.scss'

const SCREEN_QUALITY = 1

const FRONT_CAMERA = 'user'

const WIDTH_SCREEN = 1280

const HEIGHT_SCREEN = 1000

const BACK_CAMERA = { exact: 'environment' }

export const cameraIsProduction = import.meta.env.VITE_PROJECT_IS_DEV

const videoConstraints = {
  width: WIDTH_SCREEN,
  height: HEIGHT_SCREEN,
  facingMode: Boolean(cameraIsProduction) ? FRONT_CAMERA : BACK_CAMERA,
}

export const ScanMedia: FC<Props> = ({
  mask,
  onError,
  onMakeShot,
  onLoadFileFromTunduk,
}) => {
  const { openDialog, closeDialog } = useDialogBottomSheet()

  const [loading, setLoading] = useState<boolean>(true)

  const webcamRef = useRef<Webcam>(null)

  const onScreenShot = useCallback(async () => {
    const imageSrc = webcamRef?.current?.getScreenshot()

    try {
      if (imageSrc) {
        const file = dataUrlToFile(imageSrc, 'scan.webp')

        onMakeShot(file)
      } else {
        throw Error('invalid image')
      }
    } catch (error) {
      onError()
    }
  }, [webcamRef])

  const onLoadFileFromTundukHandler = () => {
    onLoadFileFromTunduk?.()
    closeDialog()
  }

  const onShowLoadFile = () => {
    openDialog({
      child: (
        <SelectTypeFile
          onError={onError}
          onLoadFile={onMakeShot}
          onLoadTunduk={onLoadFileFromTundukHandler}
        />
      ),
    })
  }

  // const onFileUpload = async (e: ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target?.files?.[0]
  //   if (file) {
  //     try {
  //       if (file) onMakeShot(file)
  //     } catch (error) {
  //       onError()
  //     }
  //   }
  // }

  const onStartLoader = () => {
    setLoading(false)
  }

  return (
    <div className={s.container}>
      <Webcam
        audio={false}
        ref={webcamRef}
        forceScreenshotSourceSize
        screenshotQuality={SCREEN_QUALITY}
        videoConstraints={videoConstraints}
        onUserMediaError={onError}
        onUserMedia={onStartLoader}
        screenshotFormat="image/jpeg"
        className={s.webcam}
      />

      {loading ? (
        <div className={s.loader}>
          <Loader />
        </div>
      ) : (
        <>
          {mask}

          <div className={s.wrapperButton}>
            <div className={s.scanDocs}>
              <AppIcon
                width={40}
                height={30}
                className={s.iconLoad}
                id={AllIcons.LOAD_FILE}
                onClick={onShowLoadFile}
              />
            </div>
            <button
              className={s.button}
              onClick={onScreenShot}
            />
          </div>
        </>
      )}
    </div>
  )
}
